<template>
  <div :style="cssVars" v-if="selectedOutcome">
    <!--HEADER-->
    <div class="row header full-width q-mb-none">
      <div class="row headerText" style="padding: 30px 20px 30px 20px">
        <div>
          <div class="row q-mb-sm">
            <span class="text-white"> What </span>
            <span class="q-ml-sm secondaryColorText">
              {{
                currentUserData.sustainabilityBusiness_name
                  ? currentUserData.sustainabilityBusiness_name
                  : "Test Business"
              }}
            </span>
          </div>
          <div class="row">
            <span class="text-white"> is doing for their </span>
            <span class="q-ml-sm secondaryColorText">
              {{ selectedOutcome.label }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <!--OUTCOME INFO-->
    <div class="outcomeSection" style="padding-top: 40px">
      <div>
        <div class="row items-center q-mb-sm" style="margin-left: 30px">
          <div style="margin-right: 20px">
            <q-img
              :src="getWhiteOutcomeImage(selectedOutcome)"
              style="width: 69px"
            ></q-img>
          </div>

          <div class="outcomeInfoHeaderText text-white">
            <div class="row">
              {{ selectedOutcome.label }}
            </div>
            <div class="row">Reduction Plan</div>
          </div>
        </div>
        <div style="width: 85%; margin: auto">
          <div class="row justify-center outcomeInfoDescription text-white">
            <div class="col q-mx-lg" style="width: 315px">
              <div class="row text-bold">What is carbon?</div>
              <div class="row">
                Carbon dioxide is one of the most important elements to life on
                planet Earth, it is also one of the primary greenhouse gases in
                the atmosphere. Carbon can be an overall term used for all
                greenhouse gases. These gases are emitted by organisations,
                events, products and people. The amount of carbon which we are
                currently producing is causing harm to our environment.
              </div>
            </div>
            <div class="col q-mx-lg" style="width: 315px">
              <div class="row text-bold">
                Why should you reduce your carbon emissions?
              </div>
              <div class="row">
                The New Zealand government has signed on with the 2030 Paris
                Agreement which aims to keep the global average temperature well
                below 2*C, ideally 1.5*C, compared to pre industrial levels. To
                help New Zealand play its part to meet this target there have
                been various changes to legislation to help meet the 2030 goal
                and the government has set a target for New Zealand to have net
                zero emissions by 2050. Everyone needs to play their part to
                help us meet these targets.
              </div>
            </div>
            <div class="col q-mx-lg" style="width: 315px">
              <div class="row text-bold">How to reduce carbon emissions?</div>
              <div class="row">
                By learning your speciﬁc data, setting goals and implementing
                solutions you can show your commitment to reducing your carbon
                footprint, which can be a point of difference for your company.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--EMISSIONS STATS-->
    <div class="full-width emissionSection"></div>
    <!--GOALS LIST-->
    <div class="full-width goalsSection" style="padding: 30px 50px 30px 50px">
      <div class="row">
        <div class="goalsHeadingTextAlt">In order to reach out target</div>
      </div>
      <div class="row">
        <div class="goalsHeadingText">
          We've set Goals for the following sources of Carbon Emissions
        </div>
      </div>
      <div class="row full-width">
        <div
          class="sourceItem"
          v-for="(source, i) in sourceListFromGoal"
          :key="i"
        >
          {{ source }}
        </div>
      </div>
      <div class="row">
        <div class="goalsHeadingText">Let's take a look</div>
      </div>
    </div>
    <!--GOAL ITEM STATS SECTION-->
    <div></div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getWhiteOutcomeImage } from "@/functions/getWhiteOutcomeImage";
export default {
  mounted() {
    this.init();
  },
  data: () => ({
    selectedOutcome: null,
  }),
  computed: {
    ...mapGetters({
      currentUserData: "auth/currentUserData",
      outcomesList: "outcomes/list",
      goals: "goals/list",
      selectedGoal: "goals/selectedGoal",
      businessSolutionsList: "solutions/business/list",
      actions: "solutions/business/actions/list",
    }),
    sourceListFromGoal() {
      let list = this.goals.map((e) => {
        if (
          e.hasOwnProperty("sourceData") &&
          e.sourceData &&
          e.sourceData.name !== ""
        ) {
          return e.sourceData.name;
        }
      });
    },
    cssVars() {
      let primaryColorFaded = this.selectedOutcome.primaryColor
        ? this.selectedOutcome.primaryColor.split("#")
        : ["", "162c47"];
      let primaryColorFadedString = "#" + primaryColorFaded[1] + "80";

      return {
        "--outcome-primary": this.selectedOutcome.primaryColor
          ? this.selectedOutcome.primaryColor
          : "#162c47",
        "--outcome-secondary": this.selectedOutcome.secondaryColor
          ? this.selectedOutcome.secondaryColor
          : "#162c47",
        "--outcome-tertiary": this.selectedOutcome.tertiaryColor
          ? this.selectedOutcome.tertiaryColor
          : "#162c47",
        "--outcome-primary-faded": primaryColorFadedString,
      };
    },
  },
  methods: {
    getWhiteOutcomeImage: getWhiteOutcomeImage,
    init() {
      this.$store.dispatch("outcomes/loadAll").then((e) => {
        if (this.outcomesList.length > 0) {
          if (this.outcomesList.length > 0) {
            if (this.$route.params.hasOwnProperty("outcomesID")) {
              let index = this.outcomesList.findIndex(
                (o) => this.$route.params.outcomesID == o.id
              );
              this.selectedOutcome = this.outcomesList[index];
            } else {
              this.selectedOutcome = this.outcomesList[0];
            }

            this.$store
              .dispatch(
                "goals/loadAllGoalsAndBasicGoalsByOutcomeID",
                this.selectedOutcome.id
              )
              .then(() => {
                this.$store.dispatch(
                  "goals/loadAllGoalsAndBasicGoalsByOutcomeID",
                  this.selectedOutcome.id
                );
              });
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  height: 126px;
  width: 1301px;
  background-color: var(--outcome-primary);
}

.headerText {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
}

.outcomeInfoHeaderText {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 36.3326px;
}

.outcomeInfoDescription {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 400;
  font-size: 12.1109px;
}

.secondaryColorText {
  color: var(--outcome-secondary);
}

.outcomeSection {
  background-color: var(--outcome-secondary);
  min-height: 432px;
}

.emissionSection {
  background-color: var(--outcome-primary);
  min-height: 540px;
}
.goalsSection {
  min-height: 200px;
}

.goalsHeadingTextAlt {
  font-family: "Montserrat";
  font-style: italic;
  font-weight: 300;
  font-size: 15px;
  color: var(--outcome-secondary);
}

.goalsHeadingText {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 29px;
  color: var(--outcome-secondary);
}

.sourceItem {
  height: 40px;
  background-color: var(--outcome-primary);
  color: var(--outcome-secondary);
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  border-radius: 5px;
  margin-right: 15px;
  padding: 5px;
  margin-top: 2px;
  margin-bottom: 2px;
}
</style>
